import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

// models
import {Tasks} from "../models/tasks/tasks";
import {Task} from "../models/tasks/task";
import {ApiMessage} from "../models/api-message";


@Injectable({
    providedIn: 'root'
})
export class TasksService {

    constructor(protected http: HttpClient) {
    }

    // get all tasks form API - only admin
    public index(userType: string, page?: number, perPage?: number, sort?: string, direction?: string, search?: string, completed?: string, priority?: string, status?: string, date_from?: string, date_to?: string, deadline_from?: string, deadline_to?: string): Observable<Tasks> {

        // let url = `${environment.api}/task`;
        let url = this.getURLbyUserType(userType);
        if (perPage) url += `?page=${page}&perPage=${perPage}&sort=${sort}&direction=${direction}&search=${search}&priority=${priority}&status=${status}`;
        if (date_from) url += `&date_from=${date_from}&date_to=${date_to}`;
        if (deadline_from) url += `&deadline_from=${deadline_from}&deadline_to=${deadline_to}`;
        if (completed) url += `&completed=${completed}`;

        return this.http.get<Tasks>(url);
    }

    // get one task from API - only admin
    public getTask(userType: string, id: number): Observable<Task> {
        const url = this.getURLbyUserType(userType);
        return this.http.get<Task>(`${url}/${id}`);
    }

    // add/create a task in API - only admin
    public createTask(userType: string, data: Task): Observable<ApiMessage> {
        const url = this.getURLbyUserType(userType);
        return this.http.post<ApiMessage>(url, data);
    }

    // update a task in API - only admin
    public updateTask(userType: string, id: number, data: Partial<Task>): Observable<ApiMessage> {
        const url = this.getURLbyUserType(userType);
        return this.http.put<ApiMessage>(`${url}/${id}`, data);
    }

    // get API URL by a logged admin/member/user
    private getURLbyUserType(userType: string): string {
        let url = '';
        switch (userType) {
            case 'admin':
                url = `${environment.api}/task`;
                break;
            case 'member':
                url = `${environment.api}/task-member`;
                break;
        }
        return url;
    }
}
